<template>
  <div>
    <div
      ref="editor"
      @blur="handleBlur($event)"
      @focus="handleFocus"
      class="editable-el"
      contenteditable="true"
      :class="{
        'edit-un-submit': isEdited,
      }"
    ></div>
  </div>
</template>

<script>
import { wrapWithTag, removeEmpty } from '@/util/string';
import { uniformLowCheck } from '@/api/qc/qcflow';
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    defValue: {
      type: String,
    },
    errorPos: {
      type: Array,
      default: [],
    },
    oriData: {
      type: Object,
    },
    lan: {
      type: String,
    },
  },
  computed: {
    isEdited() {
      return removeEmpty(this.value) !== removeEmpty(this.defValue);
    },
  },
  methods: {
    handleBlur(e) {
      this.$emit('update:value', e.target.innerText);
      this.value = e.target.innerText;
      this.lowCheck();
    },

    handleFocus() {
      this.$emit('focus');
    },
    wrapErrors(value, posArr = []) {
      if (!posArr) {
        return value;
      }
      const plainPosArr = posArr.map((item) => [item.spos, item.epos]);
      return wrapWithTag(value, plainPosArr);
    },
    updateContent(text, pos) {
      this.$refs.editor.innerHTML = this.wrapErrors(text, pos);
    },
    lowCheck() {
      uniformLowCheck({
        id: this.oriData.sentId ?? this.oriData.id,
        srcTxt: this.oriData.srcText ?? this.oriData.srcTxt,
        lan: this.lan,
        qcTxt: this.value,
      }).then((res) => {
        const usableData = res.data?.data ?? {};
        this.updateContent(this.value, usableData.posVos);
        this.$emit('error-change', usableData.errorTxts);
      });
    },
  },
  watch: {
    value() {
      this.updateContent(this.value, this.errorPos);
    },
  },
  mounted() {
    this.updateContent(this.defValue, this.errorPos);
  },
};
</script>
